<app-loading-spinner *ngIf="showSpinner"></app-loading-spinner>

<div *ngIf="!showSpinner">
  <app-menu></app-menu>
  <mat-card class="topicos-card">
    <mat-card-title class="topicos-titulo">
      <div style="text-align: center;">
        <h2>Tópicos dos participantes</h2>
      </div>
    </mat-card-title>

    <mat-card-content>

      <button mat-flat-button
      [ngStyle]="{'margin': '8px'}"
      [routerLink]="['/mentoria', 'criar-topico']"
      routerLinkActive="active">
        Criar novo tópico
      </button>

      <!-- Listagem dos tópicos -->
      <mat-card class="card-content" *ngFor="let duvida of questoes">
        <mat-card-title class="card-title" [routerLink]="['/mentoria', 'topico', duvida.id]"
        style="cursor: pointer;">
          <span>{{duvida.questao}}</span>

          <span class="spacer"></span>

          <button class="actions-normal" mat-flat-button
            [routerLink]="['/mentoria', 'topico', duvida.id]"
            routerLinkActive="active">Responder</button>
        </mat-card-title>

        <mat-card-content>
          <p>Criado por: {{duvida.userDisplayName}}</p>
          <p>{{duvida.descricao}}</p>
        </mat-card-content>

        <mat-card-actions class="actions-mobile">
          <button class="button-normal" mat-flat-button
            [routerLink]="['/mentoria', 'topico', duvida.id]"
            routerLinkActive="active">Responder</button>
        </mat-card-actions>
        <mat-divider></mat-divider>
      </mat-card>
    </mat-card-content>
  </mat-card>
</div>
